export default __webpack_public_path__ + "static/media/body-section-chest.7a58dade.png";